<template>
  <div class="pages">
    <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
      <el-menu-item index="1" >信息填写</el-menu-item>
      <el-menu-item index="2">审批</el-menu-item>
    </el-menu>
    <div  v-loading="Loading" element-loading-spinner="el-icon-loading" element-loading-text="数据加载中" v-show="isFillIn">
      <div>
        <el-form label-position="left" label-width="75px" :model="searchForm">
          <el-form-item label="项目名称:">
            <el-input class="search-input" clearable size="small" v-model="searchForm.projectName"></el-input>
            <el-button size="mini" type="primary" style="margin-right: 20px;" @click="query()">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="pricing-list">
        <div class="totle">共计<span>{{pricingList.length}}</span>条</div>
        <div class="pricing-item" v-for="(item,index) in pricingList" :key="index" @click="click(item.URL)">
          <div class="title">{{item.Title}}</div>
          <div class="applicant-time clearfix">
            <div class="applicant">项目名称：{{item.allocationTable !== undefined ? item.allocationTable.projectName : ''}}</div>
            <div class="time">申请变更日期:{{item.allocationTable !== undefined ? item.allocationTable.applyChangeDate : ''}}</div>
          </div>
          <div class="label" :class="'waiting-check'">待填写</div>
        </div>
      </div>
    </div>
    <div v-show="!isFillIn">
      <div class="pricing-list">
        <div class="totle">共计<span>{{approvalList.length}}</span>条</div>

        <div class="pricing-item" v-for="(item,index) in approvalList" :key="index" @click="click(item.URL)">
          <div class="title">{{item.Title}}</div>
          <div class="applicant-time clearfix">
            <div class="applicant">项目名称：{{item.allocationTable !== undefined ? item.allocationTable.projectName : ''}}</div>
            <div class="time">申请变更日期:{{item.allocationTable !== undefined ? item.allocationTable.applyChangeDate : ''}}</div>
          </div>
          <div class="label" :class="`waiting-pricing`">待审批</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getUnfinishedProcess,
  isProcessEffective
} from "@/api/allocation"

export default {
name: "SecondaryCommissionList",
  data(){
  return {
    activeIndex: '1',
    isFillIn: true,
    logInfo:null,
    pricingList:[],
    pricingListTemp:[],
    approvalList:[],
    Loading: false,
    searchForm: {
      projectName:""
    }
  }
  },
  methods : {
    handleSelect(a) {
      this.isFillIn = a === '1';
    },
    click(url){
      this.$router.push(url);
    },
    PersonnelDeconstruction(vals){
      vals = vals.filter(e => e.isMark === false)
      for (let item of vals) {
        item.value = item.value.replace(/\s/g, "");
        if(item.value === `${this.logInfo.EmpNo}-${this.logInfo.EmpName}`){
          return true;
        }
      }
      return false
    },
    /**
     * 100
     * */
    hundred(bodys){
      let a = bodys.filter(e => e.flowsStatus === 100 && e.dataType !== 20)
      let rA = a.filter(e => e.applicantName === this.logInfo.EmpName)
      for (let i = 0; i < rA.length; i++){
        let item = rA[i];
          item.URL = `SecondaryCommissionA?templateId=3TmkoTz9FsMZYuSeRjwkBRDLRbJvWijjpp93BUse&status=Apply&id=${item.id}&operator=${this.logInfo.EmpNo}`
          //item.URL = `SecondaryCommissionA?templateId=C4RZaoP7Aye1dFq1zLAABiCQhRzwCdSdjxiPbcbFj&status=Apply&id=${item.id}&operator=${this.logInfo.EmpNo}`
        this.initTitle(item,100)
      }
      return rA
    },
    /**
     * code 100初填写  90驳回 2
     * @param val
     * @param code
     * @param args
     */
    initTitle(val,code,args){
      switch (code) {
        case 100:
        case 200:
          val.Title = "二级佣金分配提醒!!"
              break
        case 90: {
          val.Title = "二级佣金分配提醒!!【数据驳回】"
          break
        }
        case 20:{
          val.Title = `二级佣金分配提醒!!! 【项目变更】`
          break
        }
        case 22: {
          val.Title = `二级佣金分配确认提醒!!! 【项目变更】`
          break
        }
        case 210: {
          val.Title = "二级佣金分配确认提醒!!!"
          break
        }
        case 410: {
          val.Title = `【变更提醒】${args}`
          break
        }
        case 222: {
          val.Title = `二级佣金分配提醒!!!【分佣拒绝后再分配】`
          break
        }
      }
    },
    /**
     * 200
     * */
    twoHundred(bodys){
      let b = bodys.filter(e => e.flowsStatus === 200)
      let rB = []
      let a;
      for (let i = 0; i < b.length; i++){
        const item = b[i];
        let approvals = item.approvalInfo.approvals
        console.log("appr")
        console.log(approvals)
        if (approvals.length <= 3){
          a = this.PersonnelDeconstruction(item.allocationTable.headerExtensions);
          //二次判断
          if (approvals[2] !== undefined){
            approvals[2].approvals.forEach(approval => {
              if(approval.empNo === this.logInfo.EmpNo)
                a = false
            })
          }
        }else {
          approvals.reverse()
          let result = this.IndexOf(approvals,item => item.flowsStatus === 90)
          a = this.PersonnelDeconstruction(item.allocationTable.headerExtensions);
          if(a){
            if (result - 2 === -1){
              a = approvals[result - 1].approvals[0].empNo !== this.logInfo.EmpNo;
              item.isRepeat = true
            }else{
              //二次判断
              let ResultData = approvals[result - 2].approvals.filter(e => e.empNo === this.logInfo.EmpNo)
              //let result = approvals[result - 2].approvals.filter(e => e.empNo === this.logInfo.EmpNo)
              a = (ResultData.length >= 0);
            }
          }
        }
        if (a) {
          rB.push(item)
        }
      }
      for (let i = 0; i < rB.length; i++){
        let item = rB[i];
           item.URL = `SecondaryCommissionA?templateId=3TmkoTz9FsMZYuSeRjwkBRDLRbJvWijjpp93BUse&status=AllocationFill&id=${item.id}&operator=${this.logInfo.EmpNo}`
          //item.URL = `SecondaryCommissionA?templateId=C4RZaoP7Aye1dFq1zLAABiCQhRzwCdSdjxiPbcbFj&status=AllocationFill&id=${item.id}&operator=${this.logInfo.EmpNo}`
        this.initTitle(item,200)
        if (item.dataType === 20)
          this.initTitle(item,20)
        if (item.isRepeat !== undefined && item.isRepeat === true)
          this.initTitle(item,222)
      }
      return rB
    },
    IndexOf(arr,callback){
      for (let i = 0; i < arr.length; i++) {
        let val = callback(arr[i]);
        if (val){
          return i
        }
      }
    },
    /**
     * 审批
     * */
    Approval(bodys){
      let c = bodys.filter(e => e.flowsStatus === 210)
      let rC = []
      for (const item of c) {
        let rows = item.rows;
        let row = rows.filter(e => e.time === 2  && e.approvalStatus === null && e.empNo === this.logInfo.EmpNo)
        if (row.length > 0)
          rC.push(item)
      }
      for (let i = 0; i < rC.length; i++){
        let item = rC[i];
          item.URL = `Approval?id=${item.id}&operator=${this.logInfo.EmpNo}`
        this.initTitle(item,210)
        if (item.dataType === 20)
          this.initTitle(item,22)
      }
      return rC
    },
    /**
     * 驳回
     * @param bodys
     * @returns {*}
     */
    reject(bodys){
      let d = bodys.filter(e => e.flowsStatus === 90 && e.applicantName === this.logInfo.EmpName)
      for (let i = 0; i < d.length; i++){
        let item = d[i];
          item.URL = `SecondaryCommissionA?templateId=3TmkoTz9FsMZYuSeRjwkBRDLRbJvWijjpp93BUse&status=BasicReject&id=${item.id}&operator=${this.logInfo.EmpNo}`
          //item.URL = `SecondaryCommissionA?templateId=C4RZaoP7Aye1dFq1zLAABiCQhRzwCdSdjxiPbcbFj&status=BasicReject&id=${item.id}&operator=${this.logInfo.EmpNo}`
        this.initTitle(item,90)
      }
      return d
    },
    hundredTwenty(bodys){
      let a = bodys.filter(e => e.flowsStatus === 100 && e.dataType === 20 && e.applicantNo === this.logInfo.EmpNo ) 
      for (let i = 0; i < a.length; i++){
          let item = a[i];

          item.URL = `SecondaryCommissionA?templateId=3TmkoTz9FsMZYuSeRjwkBRDLRbJvWijjpp93BUse&status=Apply&id=${item.id}&operator=${this.logInfo.EmpNo}`
          //item.URL = `SecondaryCommissionA?templateId=C4RZaoP7Aye1dFq1zLAABiCQhRzwCdSdjxiPbcbFj&status=Apply&id=${item.id}&operator=${this.logInfo.EmpNo}`
        this.initTitle(item,20,item.allocationTable.projectName)
      }
      return a
    },
    hundredTen:async function(bodys){
      let a,result;
      a = bodys.filter(e => e.flowsStatus === 410)
      result = a.filter(e => e.isProcessEffective === false  && e.applicantNo === this.logInfo.EmpNo)
      for (let i = 0; i < result.length; i++){
        let item = result[i];
        item.URL = `SecondaryCommission?templateId=3TmkoTz9FsMZYuSeRjwkBRDLRbJvWijjpp93BUse&id=${item.id}`
        // item.URL = `SecondaryCommission?templateId=C4RZaoP7Aye1dFq1zLAABiCQhRzwCdSdjxiPbcbFj&id=${item.id}`
        this.initTitle(item,410,item.allocationTable.projectName)
      }
      return result
    },
    getData : async function(){
        this.Loading = true;
        let that = this;
        let results = [],approvals = []
        //判断是否是IOS
        if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
            var oDate = new Date();
            oDate.setDate(oDate.getDate() + 7200);
            document.cookie = `logInfo=${encodeURI(JSON.stringify(this.logInfo))};expires=${oDate.toDateString()}`
        }
        await getUnfinishedProcess().then(async res => {
            let bodys = res.body;
            let rA = this.hundred(bodys)
            let rATwenty = this.hundredTwenty(bodys)
            let rB = this.twoHundred(bodys)
            approvals = this.Approval(bodys)//210
            let rD = this.reject(bodys)
            let rE = await this.hundredTen(bodys)//410 审批通过
            results = [...rA,...rB,...rD,...rATwenty,...rE]
            this.approvalList = approvals
            this.pricingList = results
            this.pricingListTemp = results
        })
        this.Loading = false;
    },
    query: function (){
      let projectname = this.searchForm.projectName
      this.pricingList = this.pricingListTemp.filter(e => e.allocationTable.projectName.indexOf(projectname) !== -1)
    }
  },
  created:async function() {
    this.logInfo = this.getLoginUserInfo();
    await this.getData();
  }
}
</script>

<style lang="less" scoped>
.search-input {
  width: 70%;
  margin-right: 9px;
}
.el-form-item {
  margin-bottom: 0px;
}
.el-menu-item {
  width: 50%;
  text-align: center;
}
.serch-form {
  background: #fff;
  padding: 10px;
  position: fixed;
  left: 0;
  top: 0;
  opacity: 1;
  z-index: 6;
  width: 100%;
  .el-form-item {
    margin-bottom: 0px;
  }
}
.pricing-list{
  margin-top: 0;
  .totle{
    font-size: 12px;
    // margin-top: 10px;
    span{
      color: #FF4346;
      padding: 0 4px;
    }
  }
  .pricing-item{
    width: 100%;
    background: #FFFFFF;
    position: relative;
    padding: 8px;
    margin-top: 10px;
    border-radius: 6px;
    box-shadow: 6px 6px 6px #CCCCCC;
    .title{
      font-size: 13px;
      color: #585354;
      line-height: 1.8;
      width: calc(100% - 40px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-bottom: 4px;
    }
    .applicant-time{
      color: #585354;
      font-size: 12px;
      line-height: 1.7;
      div.applicant{
        width: 60%;
        float: left;
      }
      div.time{
        width: 40%;
        float: right;
        text-align: right;
      }
    }
    .label{
      position: absolute;
      right: 5px;
      top: 10px;
    }
    .waiting-pricing{
      color: #3FC243;
    }
    .waiting-check{
      color: #55ACEE;
    }
  }
  .pricing-item:first-child{
    margin-top: 0;
  }
}
</style>